import React, { useEffect } from "react";
import "./GoogleTranslate.css";

const GoogleTranslate = () => {
  useEffect(() => {
    document.cookie = "googtrans= ; expires = 0";
    const googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: "auto",
          includedLanguages: "fr,ja,en,zh-CN",
          autoDisplay: false,
          layout: (window as any).google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );
    };

    (window as any).googleTranslateElementInit = googleTranslateElementInit;

    const addScript = document.createElement("script");
    addScript.setAttribute("src", "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit");
    document.body.appendChild(addScript);

    return () => {
      document.body.removeChild(addScript);
      delete (window as any).googleTranslateElementInit;
    };
  }, []);

  return <div id="google_translate_element"></div>;
};

export default GoogleTranslate;
